import MD5 from 'crypto-js/md5';
/**
 * 生成32位随机英文数字小写字符串
 */
export function generate32BitString() {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const array = new Uint32Array(32);
  window.crypto.getRandomValues(array);

  for (let i = 0; i < 32; i++) {
    result += chars[array[i] % 36];
  }
  return result;
}

/**
 * MD5加密函数
 * @param {string} str - 需要加密的字符串
 * @returns {Promise<string>} - 加密后的结果
 */
export async function md5(str) {
    return MD5(str).toString();
}

/**
 * 生成签名信息
 * @returns {Promise<Object>} - 包含str1, str2, str3, sign, tmp的对象
 */
export async function generateSignature() {
  // 生成三个32位随机字符串
  const str1 = generate32BitString();
  const str2 = generate32BitString();
  const str3 = generate32BitString();

  // 获取当前毫秒时间戳
  const tmp = Date.now().toString();

  // 处理时间戳后三位
  const lastThree = tmp.slice(-3).padStart(3, '0');
  const units = parseInt(lastThree[2], 10) || 1;  // 个位
  const tens = parseInt(lastThree[1], 10) || 1;   // 十位
  const hundreds = parseInt(lastThree[0], 10) || 1; // 百位

  // 截取字符串尾部
  const slice1 = str1.slice(-units);
  const slice2 = str2.slice(-tens);
  const slice3 = str3.slice(-hundreds);

  // 拼接并加密
  const combined = slice1 + slice2 + slice3 + tmp;
  const sign = await md5(combined);

  return { str1, str2, str3, sign, tmp };
}
